import { useMemo } from 'react';

import { computeMasterIndexAccess } from '@/pages/MasterIndex/Permissions';
import { useUserStore } from '@/store';

export default function useMasterIndexAccess() {
  const { user, userAgencyId } = useUserStore();
  return useMemo(
    () => computeMasterIndexAccess(user, userAgencyId),
    [user, userAgencyId],
  );
}
